import { getPersistedLocale } from "../assets/locales/locales";
import { polyfillGetCanonicalLocales, polyfillLocale } from ".";
import { polyfillLanguage } from "./polyfillLanguage";

export async function asyncPolyfill() {
    await polyfillGetCanonicalLocales();
    await polyfillLocale();
    await polyfillLanguage(getPersistedLocale() ?? "en-US");
}
